export default __webpack_public_path__ + "static/media/about-us-img-08.690afbbf.jpg";